module.exports = __webpack_public_path__ + "static/media/hp-home-banner-@1x.33e6ced5.jpg";